// extracted by mini-css-extract-plugin
export default {"date_head":"OldResult_date_head__JMel4","date_result":"OldResult_date_result__-5rLm"};